import styled, { css } from 'styled-components';

import { mediaDesktop } from 'utils/styles/responsive';

export const ArticleImageBlockWrapper = styled.img`
  width: 100%;
  min-width: 100%;
  aspect-ratio: 16/9;
  object-position: top;
  object-fit: cover;

  grid-column: 1/ -1;

  margin-bottom: 64px;

  ${mediaDesktop(css`
    margin-bottom: 96px;
    grid-column: 1/ -1;
  `)}
`;
